import React from 'react'

export default function ForgotPasswordPage() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Forgot Password</h1>
      <p className="text-muted-foreground">Reset your password.</p>
    </div>
  )
} 